"use strict";
/* tslint:disable:no-object-literal-type-assertion */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_KEYS = void 0;
const baseName = "goretro";
exports.CONFIGURATION_KEYS = {
    user: {
        selected: {
            sprintIds: {
                name: `${baseName}.user.selected.sprintIds`,
                chain: [],
                type: {}
            },
            boardIds: {
                name: `${baseName}.user.selected.boardIds`,
                chain: [],
                type: {}
            },
            contributorFilters: {
                name: `${baseName}.user.selected.filters`,
                chain: [],
                type: {}
            },
        },
    }
};
//# sourceMappingURL=goretro.js.map